DistributionPieChart = (function () {
    'use strict';
    var DistributionPieChart = function (container, config) {
        this.container = container;
        this.config = {
            attribute: config.attribute,
            title: config.title || "",
            marker: config.marker || null,
            labelAttribute: config.labelAttribute || null
        };
        this.labels = null;
    };

    DistributionPieChart.prototype.setData = function (data) {
        if (!data || data.length == 0) {
            return;
        }
        this.data = this.transformData(data, this.config.attribute);
        if (this.config.labelAttribute !== null) {
            this.labels = [];
            for (var i = 0; i < data.length; i++) {
                var labelKeys = this.config.labelAttribute.split('.');
                var label = data[i];
                labelKeys.forEach(function (key) {
                    label = label[key];
                });
                this.labels.push(label);
            }
        }
        this.renderChart(data);
    };

    DistributionPieChart.prototype.transformData = function (data, attribute) {
        return _.chain(data)
            .countBy(function (item) {
                return item[attribute];
            })
            .value();
    };

    DistributionPieChart.prototype.renderChart = function () {
        var trace = {
            values: _.values(this.data),
            labels: this.labels !== null ? this.labels : _.keys(this.data),
            type: 'pie',
        };
        if (this.config.marker === "color") {
            trace.marker = {
                colors: _.chain(this.data)
                    .keys()
                    .map(colorToRgb)
                    .value()
            };
        }
        Plotly.newPlot(this.container,
            [trace],
            {
                title: this.config.title || null,
            });
    };

    DistributionPieChart.prototype.clearChart = function (data) {
        Plotly.purge(this.container)
    };

    return DistributionPieChart;

    function colorToRgb(color) {
        var colors = {
            //Used in both
            'Schwarz': 'rgb(0,0,0)',
            //print colors
            'Weiss': 'rgb(240,240,240)',
            'Silber Matt': 'rgb(205,205,205)',
            'Sweet Orange':	'rgb(238,111,3)',
            'Happy Pink': 'rgb(225,0,122)',
            'Hellblau': 'rgb(0,85,164)',
            'Lindgrün':	'rgb(166,199,84)',
            'Sonnengelb':'rgb(255,236,0)',
            'Violett': 'rgb(123,71,120)',
            'Metall Gold': 'rgb(245,216,95)',
            'Metall Silber': 'rgb(205,205,205)',
            'Metall Rot': 'rgb(215,53,48)',
            'Metall Blau':	'rgb(0,85,164)',
            'Metall Rose':	'rgb(226,151,138)',
            //tape colors
            'Schneeweiss': 'rgb(230,230,230)',
            'Champagner': 'rgb(240,220,180)',
            'Tomatenrot': 'rgb(189,50,38)',
            'Türkis': 'rgb(3,171,175)',
            'Fuchsia': 'rgb(189,60,119)',
            'Pastellrose': 'rgb(252,200,220)',
            'Apfelgrün': 'rgb(93,165,23)',
            'Hellviolett': 'rgb(175,149,198)',
            'Bordeaux': 'rgb(79,3,31)',
            'Chocolate': 'rgb(69,34,17)',
            'Zitronengelb': 'rgb(217,203,34)',
            'Lachs': 'rgb(255,168,159)',
            'Mintgrün': 'rgb(157,224,218)',
            'Moosgrün': 'rgb(4,125,94)',
            'Pastellblau': 'rgb(153,192,230)',
            'Royalblau': 'rgb(4,41,154)'
        };
        return colors[color];
    }
})();